import React, { createContext, useContext, useState, useCallback } from 'react';
import { isEqual, isFunction } from 'lodash';
import { UIHelpers } from '../../../../constants/pages/UIHelpers';

const PaymentLinksUIContext = createContext();
const { initialFilter } = UIHelpers();

export function usePaymentLinksUIContext () {
    return useContext(PaymentLinksUIContext);
}

export const PaymentLinksUIConsumer = PaymentLinksUIContext.Account;

export function PaymentLinksUIProvider ({ children }) {
    const [isLoading, setIsLoading] = useState(false);
    const [queryParams, setQueryParamsBase] = useState(initialFilter);
    const [paymentLinks, setPaymentLinks] = useState([]);
    const [fetchData, setFetchData] = useState(false);

    const setQueryParams = useCallback(nextQueryParams => {
        setQueryParamsBase(prevQueryParams => {
            if (isFunction(nextQueryParams)) {
                nextQueryParams = nextQueryParams(prevQueryParams);
            }

            if (isEqual(prevQueryParams, nextQueryParams)) {
                return prevQueryParams;
            }

            return nextQueryParams;
        });
    }, []);

    const value = {
        isLoading,
        setIsLoading,
        queryParams,
        setQueryParamsBase,
        setQueryParams,
        paymentLinks,
        setPaymentLinks,
        fetchData,
        setFetchData
    };

    return <PaymentLinksUIContext.Provider value={value}>{children}</PaymentLinksUIContext.Provider>;
}
